(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function init(root) {
    if (root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    var variantInput = root.querySelector('[data-variant-input]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var quantities = Array.from(root.querySelectorAll('[data-quantity]'));
    var currentPrice = Number(root.querySelector('[data-variant-price].is-active')?.dataset.variantPrice || root.dataset.price || 0);
    var days = Number(root.querySelector('[data-day-price]')?.closest('[data-quantity]')?.querySelector('.pdp-quantity__copy small')?.textContent.match(/\d+/)?.[0] || 0);

    function updateTiers() {
      quantities.forEach(function (card) {
        var quantity = Number(card.dataset.quantity);
        var discount = Number(card.dataset.discount);
        var subtotal = currentPrice * quantity;
        var total = Math.round(subtotal * (100 - discount) / 100);
        card.querySelector('[data-tier-price]').textContent = money(total);
        var base = card.querySelector('[data-base-price]');
        if (base) base.textContent = money(currentPrice * quantity);
        var dayPrice = card.querySelector('[data-day-price]');
        if (dayPrice && days > 0 && days <= 400) dayPrice.textContent = money(total / (days * quantity)) + ' pro Tag';
      });
      root.dispatchEvent(new CustomEvent('pdp:selection', {
        bubbles: true,
        detail: {
          quantity: Number(quantityInput.value),
          price: root.querySelector('.pdp-quantity.is-active [data-tier-price]').textContent
        }
      }));
    }

    root.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-gallery-dot]');
      if (dot) {
        var index = dot.dataset.galleryDot;
        root.querySelectorAll('[data-gallery-slide]').forEach(function (slide) { slide.classList.toggle('is-active', slide.dataset.gallerySlide === index); });
        root.querySelectorAll('[data-gallery-dot]').forEach(function (item) { item.classList.toggle('is-active', item === dot); });
      }

      var tier = event.target.closest('[data-quantity]');
      if (tier) {
        quantities.forEach(function (item) {
          var active = item === tier;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-checked', String(active));
        });
        quantityInput.value = tier.dataset.quantity;
        updateTiers();
      }

      var variant = event.target.closest('[data-variant-id]');
      if (variant && root.contains(variant)) {
        root.querySelectorAll('[data-variant-id]').forEach(function (item) {
          item.classList.toggle('is-active', item === variant);
          item.setAttribute('aria-pressed', String(item === variant));
        });
        variantInput.value = variant.dataset.variantId;
        currentPrice = Number(variant.dataset.variantPrice);
        var submit = root.querySelector('.pdp-atc');
        if (submit) {
          submit.disabled = variant.dataset.available !== 'true';
          var submitLabel = submit.querySelector('.add-to-cart-text__content span span');
          if (submitLabel) submitLabel.textContent = variant.dataset.available === 'true' ? 'In den Warenkorb' : 'Ausverkauft';
        }
        updateTiers();
      }
    });

    var delivery = root.querySelector('[data-delivery-date]');
    if (delivery) {
      var date = new Date();
      var added = 0;
      while (added < 2) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
      }
      delivery.textContent = 'Lieferung voraussichtlich ' + new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit' }).format(date);
    }
    updateTiers();
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-root]').forEach(init);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
